module.exports = __webpack_public_path__ + "static/img/no-net.afc7f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-net.png
// module id = 336
// module chunks = 7